import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const calculateTotalMinutes = (secDays) => {
  return ((secDays * 365) / 60).toFixed(2);
};

const Setup = ({
  selectedRound,
  credits,
  days,
  secDays,
  offers,
  offersRejection,
  mov,
  setSelectedRound,
  setSelectCredits,
  setSelectDays,
  setSelectSecDays,
  setOffers,
  setOffersRejection,
  setMov,
  handleSelectedRound,
}) => {
  useEffect(() => {}, [selectedRound]);
  // useEffect(() => {
  //   return localStorage.removeItem('gameSettingClicked');
  // }, []);
  return (
    <div className="setup">
      <h1>Edit Setup</h1>
      <form className="p-4">
        <div className="form-group">
          <label htmlFor="temp-id">Select Rounds</label>
          <select
            className="form-control"
            name="selectedRound"
            value={selectedRound}
            onChange={(e) => {
              setSelectedRound(e.target.value);
              handleSelectedRound(e.target.value);
            }}>
            <option selected value="easy">
              Easy
            </option>
            <option value="medium">Medium</option>
            <option value="hard">Hard</option>
            <option value="demo">Demo</option>
          </select>
        </div>
        <div className="form-row">
          <div className="col-md">
            <label htmlFor="temp-id">No. of Credits per user</label>
            <input
              type="number"
              className="form-control"
              name="credits"
              value={credits}
              onChange={(e) => {
                setSelectCredits(e.target.value);
              }}
              placeholder="Credits"
            />
          </div>
          <div className="col-md">
            <label htmlFor="temp-id">No. of Days </label>
            <input
              type="number"
              className="form-control"
              name="days"
              value={days}
              onChange={(e) => {
                setSelectDays(e.target.value);
              }}
              placeholder="Days"
            />
          </div>
          <div className="col-md">
            <label htmlFor="temp-id">No. of Seconds per day </label>
            <input
              type="number"
              className="form-control"
              name="sec_days"
              value={secDays}
              onChange={(e) => {
                setSelectSecDays(e.target.value);
              }}
              placeholder="Seconds"
            />
          </div>
        </div>
        <div className="form-group row mt-3">
          <label htmlFor="temp-id" className="col-sm-2 col-form-label">
            Total Minutes:
          </label>
          <div className="col-sm-5">
            <input
              type="number"
              readOnly
              className="form-control-plaintext"
              name="total-minutes"
              value={calculateTotalMinutes(secDays)}
              placeholder="Total Minutes"
            />
          </div>
        </div>
        <div className="form-row">
          <div className="col-md">
            <label htmlFor="temp-id">Gap between offers</label>
            <input
              type="number"
              className="form-control"
              name="offers"
              value={offers}
              onChange={(e) => {
                setOffers(e.target.value);
              }}
              placeholder="Gaps"
            />
          </div>
          <div className="col-md">
            <label htmlFor="temp-id">Offer time after rejection </label>
            <input
              type="number"
              className="form-control"
              name="offers_rejection"
              value={offersRejection}
              onChange={(e) => {
                setOffersRejection(e.target.value);
              }}
              placeholder="Offers"
            />
          </div>
          <div className="col-md">
            <label htmlFor="temp-id">Movilennium </label>
            <input
              type="number"
              className="form-control"
              name="mov"
              value={mov}
              onChange={(e) => {
                setMov(e.target.value);
              }}
              placeholder="Movilennium "
            />
          </div>
        </div>
      </form>
      {/* {localStorage.removeItem('gameSettingClicked')} */}
    </div>
  );
};

Setup.propTypes = {
  selectedRound: PropTypes.number,
  credits: PropTypes.number,
  days: PropTypes.number,
  secDays: PropTypes.number,
  offers: PropTypes.number,
  offersRejection: PropTypes.number,
  mov: PropTypes.number,
  setSelectedRound: PropTypes.func,
  setSelectCredits: PropTypes.func,
  setSelectDays: PropTypes.func,
  setSelectSecDays: PropTypes.func,
  setOffers: PropTypes.func,
  setOffersRejection: PropTypes.func,
  setMov: PropTypes.func,
  handleSelectedRound: PropTypes.func,
};

Setup.defaultProps = {
  selectedRound: '',
  credits: '',
  days: '',
  secDays: '',
  offers: '',
  offersRejection: '',
  mov: '',

  setSelectedRound: '',
  setSelectCredits: '',
  setSelectDays: '',
  setSelectSecDays: '',
  setOffers: '',
  setOffersRejection: '',
  setMov: '',
  handleSelectedRound: '',
};

export default Setup;
